import { cx, css, useTheme } from '@fable/theme'
import ProfileCard from '../../../../components/profile/ProfileCard'
import ProfileActions from './ProfileActions'
import { useTypedSelector } from '../../../../hooks'
import { SocialLinks, getSocialLinks } from '@fable/components'
import { User } from '@fable/types'

const ProfileHeader: React.VFC = () => {
  const { user } = useTypedSelector(({ social }) => social)
  const { colors } = useTheme()

  const styles = {
    container: css`
      background-color: ${colors.whiteFang};
      margin-bottom: 40px;
    `,
  }
  // https://www.figma.com/file/q7KlcLyYFswO2QB3I4BWmE/Interests-Graph-on-Web?node-id=4%3A2095
  // if public show follow button

  const links = getSocialLinks<User>({ profile: user.data })

  return (
    <div className={cx(styles.container, 'pad-edges')}>
      <ProfileCard user={user.data} />
      {user.data?.private_profile ? null : (
        <div
          className={css`
            margin: 16px auto;
          `}
        >
          <SocialLinks links={links} />
        </div>
      )}
      <ProfileActions
        className={css`
          margin-top: 24px;
        `}
      />
    </div>
  )
}

export default ProfileHeader
